import { mapProps } from 'recompose'

import InputField from './InputField'
import CheckBox from './CheckBox'

const InputFieldRedux = mapProps(
  ({ meta: { touched, error } = {}, input: { ...inputProps }, ...props }) => {
    return {
      errorText: touched && error,
      ...inputProps,
      ...props,
      fullWidth: true,
    }
  },
)(InputField)

const CheckBoxRedux = mapProps(
  ({ meta: { touched, error } = {}, input: { ...inputProps }, ...props }) => {
    const value = props.values
      ? Object.entries(props.values).find(o => o[1] === inputProps.value)
      : !!inputProps.value
    // Hakish approach - we are assuming that checkbox has values and value
    const checked = props.values ? (value && value[1]) || false : value
    return {
      errorText: touched && error,
      ...inputProps,
      ...props,
      checked,
    }
  },
)(CheckBox)

// InputField compatible with redux-form
export { InputFieldRedux as InputField }
export FileInput from './FileInput'
export FileInputPreview from './FileInputPreview'
export ImageInput from './ImageInput'
export Input from './Input'
export InputGroup from './InputGroup'
export InputGroupAddon from './InputGroupAddon'
export Label from './Label'
export { CheckBoxRedux as CheckBox }



// WEBPACK FOOTER //
// ./ui/Input/index.js